import { Link } from 'react-router-dom'

const WelcomeSection = () => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.opacity = '0.8'
  }

  const handleMouseLeave = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.opacity = '1'
  }

  return (
    <section
      className="w-full bg-[#F7F8FA] px-4 sm:px-8 md:px-16 lg:px-16 pt-8 sm:pt-12 md:pt-16 pb-8 sm:pb-12 md:pb-16 flex items-center justify-center min-h-[300px] sm:min-h-[350px] md:min-h-[400px]"
    >
      <div className="w-full max-w-4xl text-center px-4">
        <h2 className="font-['Cardo'] text-2xl sm:text-3xl md:text-[32px] text-[#764F2B] font-normal mb-4 sm:mb-6 md:mb-6 text-center">
          Welcome to FGA Prestige
        </h2>
        
        <p className="font-['Plus_Jakarta_Sans'] text-sm sm:text-base md:text-[16px] text-[#7b7b7b] leading-relaxed mb-6 sm:mb-8 md:mb-6 text-center max-w-[800px] mx-auto">
          Whether you crave the thrill of the unknown or the comfort of curated perfection, we invite you to dive in. With us, every experience is a front-row seat to the remarkable—because who we are is defined by the journeys we create, and the memories we help you make.
        </p>
        
        <Link
          to="/membership-enquiry"
          className="bg-black text-white font-['Plus_Jakarta_Sans'] text-sm sm:text-base md:text-[16px] px-6 sm:px-8 md:px-9 py-3 sm:py-4 md:py-[14px] transition-all duration-300 ease-in-out hover:opacity-80 no-underline inline-block"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Become a Member
        </Link>
      </div>
    </section>
  )
}

export default WelcomeSection